import { useState } from 'react';
import { Star, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, apiError } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { shareSong } from '@/lib/share';

export function LikeButton({ entryId, likes, liked, isOwner, onChange }) {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState({ likes, liked });

  const toggle = async () => {
    if (!session) { navigate('/login'); return; }
    if (isOwner) { toast.error('Vous ne pouvez pas voter pour votre propre participation.'); return; }
    setBusy(true);
    try {
      const { data } = await api.post('/likes/toggle', { entry_id: entryId });
      const next = { likes: data.likes, liked: data.liked };
      setState(next);
      onChange?.(next);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy || isOwner}
      data-testid={`like-button-${entryId}`}
      className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold transition-all ${
        state.liked ? 'bg-brand/15 text-brand' : 'bg-surface-card text-white hover:bg-surface-cardHover'
      } ${isOwner ? 'cursor-not-allowed opacity-60' : ''}`}
      title={isOwner ? 'Vous ne pouvez pas voter pour votre propre participation' : 'Aimer'}
    >
      <Star className={`h-4 w-4 ${state.liked ? 'fill-brand text-brand' : ''}`} />
      <span className="font-mono">{state.likes}</span>
    </button>
  );
}

export function ShareButton({ slug, title, creator, className = '', label = false }) {
  return (
    <button
      onClick={() => shareSong({ slug, title, creator })}
      data-testid={`share-button-${slug}`}
      className={`flex items-center gap-1.5 rounded-full bg-[#25D366]/15 px-3 py-1.5 text-sm font-semibold text-[#25D366] transition-all hover:bg-[#25D366]/25 ${className}`}
      title="Partager sur WhatsApp"
    >
      <Share2 className="h-4 w-4" />
      {label && <span>Partager</span>}
    </button>
  );
}
